import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { Cover } from '../../components/primitives/Cover';
import { SocialConnectTarget } from '../types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import shared from '../Promote.module.scss';
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ConnectTargetRowProps {
  target: SocialConnectTarget;
  isPicked: boolean;
  onPick: (externalId: string) => void;
}

/** One page or account the login could post as. */
const ConnectTargetRowComponent: React.FC<ConnectTargetRowProps> = ({ target, isPicked, onPick }) => {
  const pick = useCallback(() => onPick(target.externalId), [onPick, target.externalId]);

  return (
    <button
      type="button"
      role="radio"
      aria-checked={isPicked}
      className={clsx(shared.pickerCard, isPicked && shared.pickerCardActive)}
      onClick={pick}
    >
      <Cover src={target.avatarUrl} label={target.displayName} size={32} radius="50%" />
      <span className={shared.rowBody}>
        <span className={shared.rowTitle}>{target.displayName}</span>
        {target.handle === null ? null : <span className={styles.identityHandle}>{target.handle}</span>}
      </span>
    </button>
  );
};

export const ConnectTargetRow = TypedMemo(ConnectTargetRowComponent);
